import { render } from "./NewSubModal.vue?vue&type=template&id=6307efb8"
import script from "./NewSubModal.vue?vue&type=script&lang=js"
export * from "./NewSubModal.vue?vue&type=script&lang=js"

import "./NewSubModal.vue?vue&type=style&index=0&id=6307efb8&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__